import React from 'react';
import _ from 'lodash';

class Table extends React.Component {
    
    
    
    renderFilas(){
            return _.map(this.props.datos.solution,(item, index) => {
            return (<tr key={index}>
                    <td>{index+1}</td>
                    <td>{item}</td>
                    </tr>
            )});
    }


    render(){
        
        if (this.props.datos.solution.length > 0){
            
            return(
                <table className ="ui celled table">
                  <thead>
                    <tr>
                        <th>Iteracion</th>
                        <th>Solución</th>
                    </tr>
                  </thead>
                  <tbody>
                      {this.renderFilas()}
                  </tbody>
                </table>
            )
        } else{
            return(<div></div>)
        }
    }
}
    
export default Table;